import { emptyList } from '@constants/empty';

export const getItem = (state, itemUID) => state.items.data[itemUID];

export const getBatchByUID =
  (batchUID) =>
  ({ batches }) => {
    const batch = batches.batchDetails[batchUID];
    return batch;
  };

export const isEnrolledInBatch =
  (batchUID) =>
  ({ batches }) => {
    return batches.data[batchUID]?.isEnrolled;
  };

export const getBatchNameByUID =
  (batchUID) =>
  ({ batches }) => {
    return batches.data[batchUID]?.name;
  };

export const getAuthorsInABatch =
  (batchUID) =>
  ({ batches }) => {
    return batches.data[batchUID]?.authors;
  };

export const getTopicGroupsInABatch =
  (batchUID) =>
  ({ batches }) => {
    return batches.topicGroups[batchUID];
  };

export const getConceptsTopicWiseInTGInBatch =
  (batchUID, topicGroupUID) =>
  ({ batches }) => {
    return batches.topicsWithConcepts?.[`${batchUID}_${topicGroupUID}`];
  };

export const getConceptCoursesInBatch =
  (batchUID, conceptUID) =>
  ({ paginator }) => {
    return paginator.conceptCourses?.[`${batchUID}_${conceptUID}`];
  };
export const getBatchScheduleClasses =
  (batchUID) =>
  ({ batches }) => {
    return batches.scheduledClasses?.[batchUID];
  };

export const getCalendarData = ({ batches }) => {
  return batches.calendarData;
};

export const getRecordedBatchData = ({ batches }) => {
  return batches.recordedBatchData;
};

export const getIsLoading = ({ batches }) => {
  return batches.isLoading;
};

export const getFeedbacks =
  (goalUID) =>
  ({ batches }) => {
    return batches.feedbacks?.[goalUID]?.results || emptyList;
  };
